import { ThemeType } from "./AiAppThemeData";
import { StoreBase } from "../../../base/cutil/StoreBase";
import { DarkTheme } from "./DarkTheme";
import { LightTheme } from "./LightTheme";
import { ATheme } from "./ATheme";
import { BTheme } from "./BTheme";
import { CTheme } from "./CTheme";
import { DTheme } from "./DTheme";
import { ETheme } from "./ETheme";
import { FTheme } from "./FTheme";
import { GTheme } from "./GTheme";
import { BgATheme } from "./BgATheme";
import { BgBTheme } from "./BgBTheme";
import { BgCTheme } from "./BgCTheme";
import { BgDTheme } from "./BgDTheme";
import { BgETheme } from "./BgETheme";
import { BgFTheme } from "./BgFTheme";
import { BgGTheme } from "./BgGTheme";
import { BgHTheme } from "./BgHTheme";
import { BgITheme } from "./BgITheme";
import { BgJTheme } from "./BgJTheme";
export class AppThemeStoreState {
    constructor() {
        this.theme = ThemeType.LIGHT;
    }
    copyWith(params) {
        const state = new AppThemeStoreState();
        state.theme = params.theme ?? this.theme;
        return state;
    }
}
export class AiAppThemeStore extends StoreBase {
    constructor() {
        super(() => new AppThemeStoreState());
        this.appThemeDatas = {
            [ThemeType.LIGHT]: LightTheme.theme,
            [ThemeType.DARK]: DarkTheme.theme,
            [ThemeType.THEMEA]: ATheme.theme,
            [ThemeType.THEMEB]: BTheme.theme,
            [ThemeType.THEMEC]: CTheme.theme,
            [ThemeType.THEMED]: DTheme.theme,
            [ThemeType.THEMEE]: ETheme.theme,
            [ThemeType.THEMEF]: FTheme.theme,
            [ThemeType.THEMEG]: GTheme.theme,
            [ThemeType.THEMEBGA]: BgATheme.theme,
            [ThemeType.THEMEBGB]: BgBTheme.theme,
            [ThemeType.THEMEBGC]: BgCTheme.theme,
            [ThemeType.THEMEBGD]: BgDTheme.theme,
            [ThemeType.THEMEBGE]: BgETheme.theme,
            [ThemeType.THEMEBGF]: BgFTheme.theme,
            [ThemeType.THEMEBGG]: BgGTheme.theme,
            [ThemeType.THEMEBGH]: BgHTheme.theme,
            [ThemeType.THEMEBGI]: BgITheme.theme,
            [ThemeType.THEMEBGJ]: BgJTheme.theme,
        };
    }
    setTheme(theme) {
        const newState = this.state.copyWith({ theme });
        this.emit(newState);
    }
    get theme() {
        return this.state.theme;
    }
    get themeDatas() {
        return this.appThemeDatas[this.state.theme];
    }
}
